var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSellUnitsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 12,
    viewBox: "0 0 21 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 11L12.6314 3.13137C12.2354 2.73535 12.0373 2.53735 11.809 2.46316C11.6082 2.3979 11.3918 2.3979 11.191 2.46316C10.9627 2.53735 10.7646 2.73535 10.3686 3.13137L7.63137 5.86863C7.23535 6.26465 7.03735 6.46265 6.80902 6.53684C6.60817 6.6021 6.39183 6.6021 6.19098 6.53684C5.96265 6.46265 5.76465 6.26465 5.36863 5.86863L0.5 1M20.5 11H13.5M20.5 11V4",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellUnitsIcon);
export default __webpack_public_path__ + "static/media/sell_units_icon.4f8c0ae501fdc88863c118fd61e7e3a7.svg";
export { ForwardRef as ReactComponent };